import React from 'react';
import './AcademySolutionsOffer.css'; // Import your CSS file for styling

const AcademySolutionsOffer = () => {
    return (
        <section className="academy-solutions-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">                  
                        <h2>ליווי פרויקטים מקצה-לקצה וגם מעבר</h2>
                        <p className="lead">
                           אנחנו מביאים קדמה של טכנולוגיה חדשנית גם לעסקים קטנים ובינוניים
                        </p>
                    </div>
                </div>

                {/* Online Courses Section */}
                <div className="row">
                    <div className="col-md-6">
                        <h3>פיתוח תוכנה</h3>
                        <p>
                            פיתוח תוכנה לאתרי אינטרנט, לטלפון האישי או למערכת ההפעלה. 
                        </p>
                    </div>
                    <div className="col-md-6">
                        {/* <img src="/images/online-courses.jpg" alt="Online Courses" className="img-fluid" /> */}
                    </div>
                </div>

                {/* Skill Development Programs Section */}
                <div className="row">
                    <div className="col-md-6">
                        {/* <img src="/images/skill-development.jpg" alt="Skill Development Programs" className="img-fluid" /> */}
                    </div>
                    <div className="col-md-6">
                        <h3>תוכניות לפיתוח מיומנויות</h3>
                        <p>
                            העשרו את המיומנויות המקצועיות שלכם עם תוכניות פיתוח המיועדות אליכם. אנו מציעים הכשרה מעשית, סדנאות ותעודות כדי לספק לכם יכולת מעשית לצמיחה מקצועית.
                        </p>
                    </div>
                </div>

                {/* Learning Management System (LMS) Section */}
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 text-center">
                        <h3>מערכת ניהול למידה (LMS)</h3>
                        <p>
                            המערכת המתקדמת שלנו לניהול למידה מספקת פלטפורמה חלקה ואינטראקטיבית למורים ולומדים. ניהול קורסים, מעקב אחר התקדמות וקידום למידה שיתופית - הכל בקלות.
                        </p>
                    </div>
                </div>

                {/* Professional Development Section */}
                <div className="row">
                    <div className="col-md-6">
                        <h3>פיתוח מקצועי</h3>
                        <p>
                            השקיעו בצמיחתכם המקצועית עם תוכניות פיתוח מקצועיות מתואמות אישית. הישארו מעודכנים בתעשייתכם וצמחו מקצועית עם מיומנויות חדשות וקבלת מידע אחרון.
                        </p>
                    </div>
                    <div className="col-md-6">
                        {/* <img src="/images/professional-development.jpg" alt="Professional Development" className="img-fluid" /> */}
                    </div>
                </div>

                {/* Call-to-Action Section */}
                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <p className="lead">
                            מוכנים להתחיל במסע למידה? גלו את פתרונות האקדמיה שלנו ופתחו את עולמם של ידע ופיתוח מיומנויות.
                        </p>
                        <a href="contact1" className="btn btn-primary btn-lg">צור איתנו קשר</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AcademySolutionsOffer;
